import React, { useContext } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
// import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Button } from '@material-ui/core';
// import NotificationsIcon from '@material-ui/icons/Notifications';
import { UserContext } from '../providers/UserProvider';
import { signOut } from '../firebase/signOut';
import { getAppName } from '../utilities/getAppName';
import { MainListItems, SecondaryListItems } from './listItems';
import userBookingTime from './Book'
import Members from './Members';
import Member from './Member';
import ClosedDays from './ClosedDays';
import AdminUsers from './AdminUsers';
import AdminUser from './AdminUser';
import Stores from './Stores';
import Store from './Store';
import BookableSlots from './BookableSlots';
import Book from './Book';
import ListUsersPerTime from './ListUsersPerTime';



const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    textAlign: 'left'
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));



export default function Dashboard() {

  const { user } = useContext(UserContext);
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleSignOut = async () => {
    await signOut();
  }

  const Copyright = () => (
    <Typography variant="body2" color="textSecondary" align="center">
      {`Copyright © ${getAppName()} ${new Date().getFullYear()}`}
    </Typography>
  );

  return (
    <Router>

      <div className={classes.root}>

        <CssBaseline />

        <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
          <Toolbar className={classes.toolbar}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
            >
              <MenuIcon />
            </IconButton>
            <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
              {getAppName()}
            </Typography>
            {/* <IconButton color="inherit">
            <Badge badgeContent={4} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
            <Typography component="p" variant="body1" color="inherit">
              {user.firstName}{user.role && ", " + user.role}.
            </Typography>
            <Button
              variant='text'
              style={{ marginTop: 0, color: '#fff' }}
              onClick={handleSignOut}
            >Logga ut</Button>
          </Toolbar>
        </AppBar>

        <Drawer
          variant="permanent"
          classes={{
            paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
          }}
          open={open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <List>{MainListItems(user?.accessLevel)}</List>
          <Divider />
          <List>{SecondaryListItems}</List>
        </Drawer>

        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={3}>
              <Grid item xs={12}>

                <Switch>
                  <Route
                    path={"/rodadagar"}
                    exact={true}
                    children={
                      <ClosedDays />
                    }
                  />
                  <Route
                    path={"/kunder"}
                    exact={true}
                    children={
                      <Members />
                    }
                  />
                  <Route
                    path="/kunder/:userId"
                    exact={true}
                    children={
                      <Member />
                    }
                  />
                  <Route
                    path="/butiker"
                    exact={true}
                    children={
                      <Stores />
                    }
                  />
                  <Route
                    path="/butiker/:storeId"
                    exact={true}
                    children={
                      <Store />
                    }
                  />
                  <Route
                    path="/butiker/:storeId/bokningsbara-tider"
                    exact={true}
                    children={
                      <BookableSlots />
                    }
                  />
                  <Route
                    path="/butiker/:storeId/boka-tid/:eventId?"
                    exact={true}
                    children={
                      <Book />
                    }
                  />
                  <Route path="/admin-anvandare/:userId"
                    exact={true}
                    children={
                      <AdminUser />
                    }
                  />
                  <Route
                    path={"/admin-anvandare"}
                    exact={true}
                    children={
                      <AdminUsers />
                    }
                  />
                  <Route
                    path={"/butiker/:storeId/boka-tid/:eventId?/tid/:slotId?"}
                    exact={true}
                    children={
                      <ListUsersPerTime />
                    }

                  />
                </Switch>

              </Grid>

            </Grid>
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    </Router>
  );
}